// Interface cho từng vị trí ký
export interface SignaturePosition {
  id: string;
  type: string;
  x: number;
  y: number;
  with: number;
  height: number;
}

// Interface cho thông tin ký trên từng trang
export interface SignaturePage {
  page: number;
  list: SignaturePosition[];
}

// Interface cho thông tin người dùng
export interface User {
  userName: string;
  email: string;
}

// Interface cho mỗi tài liệu với danh sách trang ký
export interface Documents {
  title: string;
  user: User;
  ky: SignaturePage[];
}

/**
 * Hàm lấy Document theo id từ danh sách tài liệu dựa trên SignaturePosition
 * @param documentsList Danh sách các tài liệu
 * @param signatureId Id của SignaturePosition cần tìm
 * @returns Document chứa SignaturePosition nếu tìm thấy, ngược lại trả về null
 */
export function findDocumentBySignatureId(
  documentsList: Documents[],
  signatureId: string
): Documents | null {
  for (const document of documentsList) {
    for (const page of document.ky) {
      const foundSignature = page.list.find(
        (position) => position.id === signatureId
      );
      if (foundSignature) {
        return document;
      }
    }
  }
  return null; // Trả về null nếu không tìm thấy Document với id đã cho
}
export const listColor = [
  "blue",
  "#6d4b40",
  "#f06418",
  "#fc8c0c",
  "#d9d02f",
  "#6bd731",
  "#2bdd66",
  "#09b8ff",
  "#099cff",
  "#5474b47",
  "#1f32c4",
  "#4f23c0",
  "#504c97",
  "#7b2eda",
  "#8931b2",
  "#f01879",
  "#c91a52",
  "red",
  "dark",
  "gray",
  "red",
  "pink",
  "grape",
  "violet",
  "indigo",
  "blue",
  "cyan",
  "green",
  "lime",
  "yellow",
  "orange",
  "teal",
];
